import type { StructuredSearchStore } from "@/components/StructuredSearch/stores/structured-search/structured-search-store";
import { REQUESTS_SIDEBAR_URL_NAMESPACE } from "@/components/StructuredSearch/hooks/structuredSearchUrlNamespaces";
import { applyStructuredSearchStateToSearchParams } from "@/components/StructuredSearch/hooks/useStructuredSearchURLSync";
import {
  appendReviewLogsDrawerIntent,
  appendReviewLogsReturnTo,
  buildReviewLogsReturnTo,
  stripReviewLogsDrawerIntent,
} from "@/utils/requestLogUrlParams";

/** Builds request-detail search from the sidebar store into the sidebar URL namespace. */
export const buildSidebarRequestNavigationSearch = ({
  sidebarStore,
  returnPathname,
  returnSearch,
}: {
  sidebarStore: StructuredSearchStore;
  returnPathname: string;
  returnSearch: string;
}): string => {
  const params = applyStructuredSearchStateToSearchParams(
    new URLSearchParams(stripReviewLogsDrawerIntent(returnSearch).replace(/^\?/, "")),
    {
      filters: sidebarStore.filters,
      dateRange: sidebarStore.dateRange,
      q: sidebarStore.q,
      pageIndex: sidebarStore.pageIndex,
      pageSize: sidebarStore.pageSize,
      sorting: sidebarStore.sorting,
    },
    { namespace: REQUESTS_SIDEBAR_URL_NAMESPACE },
  );
  const search = params.toString() ? `?${params.toString()}` : "";
  const returnTo = buildReviewLogsReturnTo(
    returnPathname,
    stripReviewLogsDrawerIntent(returnSearch),
  );
  return appendReviewLogsDrawerIntent(appendReviewLogsReturnTo(search, returnTo));
};
